import { createSearchStore } from '@/stores/create-search-store';

export const usePropertySearchStore = createSearchStore({
  storeName: 'PropertySearchStore',
  defaultSortField: 'updatedAt',
  defaultItemsPerPage: 100,
});
